import { createSlice } from "@reduxjs/toolkit";
import { addContact, getContact, getDetailContact, updateContact, deleteContact, bulkImportContacts } from "./thunk";
import { s } from "@fullcalendar/core/internal-common";


export const initialState = {
    contacts: [],
    contactDetail: {} as any,
    error: {},
    loading: false
};

const ContactSlice = createSlice({
    name: 'Contact',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getContact.pending, (state: any, action: any) => {
            state.loading = true;
        });
        builder.addCase(getContact.fulfilled, (state: any, action: any) => {
            state.contacts = action.payload;
            state.loading = false;
        });
        builder.addCase(getContact.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
            state.loading = false;
        })

        builder.addCase(addContact.pending, (state: any, action: any) => {
        });
        builder.addCase(addContact.fulfilled, (state: any, action: any) => {
            state.contacts = [...state.contacts, action.payload]
            state.contactDetail = action.payload;
        });
        builder.addCase(addContact.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        })

        builder.addCase(getDetailContact.pending, (state: any, action: any) => {
        });
        builder.addCase(getDetailContact.fulfilled, (state: any, action: any) => {
            state.contactDetail = action.payload;
        });
        builder.addCase(getDetailContact.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        })

        builder.addCase(updateContact.pending, (state: any, action: any) => {
        });
        builder.addCase(updateContact.fulfilled, (state: any, action: any) => {
            const index = state.contacts.findIndex((c: any) => c.id === action.payload.id);
            if (index !== -1) {
                state.contacts[index] = action.payload;
            }

            state.contactDetail = action.payload;
        });
        builder.addCase(updateContact.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        })

        builder.addCase(deleteContact.pending, (state: any, action: any) => {
        });
        builder.addCase(deleteContact.fulfilled, (state: any, action: any) => {
            state.contacts = state.contacts.filter((contact: any) => contact.id !== action?.payload);
            if (state.contactDetail?.id === action.payload) {
                state.contactDetail = {};
            }
        });
        builder.addCase(deleteContact.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        })

        builder.addCase(bulkImportContacts.pending, (state: any, action: any) => {
            state.loading = true;
        });
        builder.addCase(bulkImportContacts.fulfilled, (state: any, action: any) => {
            state.contacts = [...action.payload, ...state.contacts];
        state.loading = false;
        });
        builder.addCase(bulkImportContacts.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
            state.loading = false;
        });
    }
});

// export const {}

export default ContactSlice.reducer;

